import { useMemo, useState } from 'react';
import { ArtistIndexModel, ArtistModel } from 'models';
import {
	Flex,
	Text,
	Card,
	CardHeader,
} from '@chakra-ui/react';
import RefreshBadge from 'components/RefreshBadge/RefreshBadge';
import ArtistMetricCard from '../Artist/ArtistMetricCard/ArtistMetricCard';
import IndexChartCore from './IndexChartCore';
import { MarketDateFilter } from 'models/types';

interface ArtistIndexChartProps {
	artist: ArtistModel;
	artistIndexData: ArtistIndexModel;
	showLastCalculationDate?: boolean;
	showTitle?: boolean;
	showArtistName?: boolean;
	showFilters?: boolean;
	showMetricCard?: boolean;
}

function ArtistIndexChart({ artist, artistIndexData, showLastCalculationDate, showTitle = true, showArtistName = true, showFilters = true, showMetricCard = true }: ArtistIndexChartProps) {
	const [selectedRange, setSelectedRange] = useState<MarketDateFilter>(MarketDateFilter.MAX);

	const filteredBackfilled = useMemo(() => {
		return artistIndexData.filterDataByMarketDateFilter(
			selectedRange,
			true
		);
	}, [artistIndexData, selectedRange]);

	const metric = filteredBackfilled.length
		? filteredBackfilled[filteredBackfilled.length - 1].weightedIndex
		: 0;
	const priorMetric = filteredBackfilled.length
		? filteredBackfilled[0].weightedIndex
		: undefined;
	
	console.log('selected range is', selectedRange);
	console.log('prior metric is', priorMetric);

	const renderTitle = () => {
		return (
			<Flex direction={'row'} gap={4} alignItems={'center'}>
				<Text textAlign="left" fontSize='md' fontWeight='bold' mb='6px'>
					Edition Index History
				</Text>
				{artistIndexData.recalculate && <RefreshBadge label={'Updating'} />}
			</Flex>
		);
	};

	function renderMetricCard() {
		if (showMetricCard && filteredBackfilled.length) {
			return (
				<ArtistMetricCard artist={artist} metric={metric} priorMetricValue={priorMetric} showBorder={false} showLabel={showArtistName} />
			)
		}
	}

	function renderLastCalculationDate() {
		return (
			<Text fontWeight='light' textAlign={'start'} fontSize={'xs'}>
				{artistIndexData.lastCalculationDate?.format('llll')}
			</Text>
		)
	}

	return (
		<Card paddingTop={7} paddingX={4} borderRadius={8} width={'100%'} display={'flex'} flexDirection={'column'}>
			<CardHeader paddingY={0}>
				<Flex direction='column' alignSelf='flex-start' width={'100%'}>
					{showTitle && renderTitle()}
					{renderMetricCard()}
					{showLastCalculationDate && renderLastCalculationDate()}
				</Flex>
			</CardHeader>
			<IndexChartCore indexData={artistIndexData.backfilledData} showFilters={showFilters} chartId={artist.id} onFilterChange={(filter) => setSelectedRange(filter)} />
		</Card>
	);
}

export default ArtistIndexChart;
